/**
 * LoginView Component
 * Inlog scherm voor Microsoft Entra ID authenticatie
 */

import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../config/authConfig';
import logo from '../assets/logo.png';
import './LoginView.css';

export const LoginView: React.FC = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch((error) => {
      console.error('Login error:', error);
    });
  };

  return (
    <div className="login-view">
      <div className="login-card">
        <img src={logo} alt="WIJeindhoven" className="login-logo" />
        
        <h1 className="login-title">Gesprekken Opname</h1>
        
        <p className="login-subtitle">
          Meld je aan met je WIJeindhoven account om gesprekken op te nemen en op te slaan.
        </p>

        <button onClick={handleLogin} className="btn-login">
          <svg className="login-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path 
              d="M15 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H15M10 17L15 12M15 12L10 7M15 12H3" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
          Inloggen met Microsoft
        </button>

        <div className="login-info">
          <p className="info-text">
            <svg className="info-icon" viewBox="0 0 20 20" fill="currentColor">
              <path 
                fillRule="evenodd" 
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" 
                clipRule="evenodd"
              />
            </svg>
            Deze applicatie is alleen toegankelijk voor medewerkers van WIJeindhoven
          </p>
        </div>
      </div>
    </div>
  );
};